import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "", // Change this to your API
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
